import { useEffect, useState } from "react";
import styles from "./Select.module.css";

const Select = ({data: incData, selectedValue, onChange, isLoading, reducedFontSize, disabled = false }) => {
  const [data, setData] = useState(incData);
  useEffect(() => {
    setData(incData);
    // console.log("pos: ", pos, " type: ", type ? (`${type} ${title ? title.substring(0,20) : "no title"}`) : (`question: ${title ? title.substring(0,20) : ""}`))
    // setQuestionType(props.questionType);
  }, [incData, selectedValue]);

  // console.log("select data: ", data);
  // console.log("selectedValue: ", selectedValue);

  const clickHandler = (e) => {
    e.stopPropagation();
  }

  return (
    <select 
      className={`${styles.select} nexiColor fw-bold w-100 mw-50`} 
      style={reducedFontSize && {fontSize: "0.9em"}}
      defaultValue={selectedValue ? selectedValue : 0} 
      onChange={onChange}
      disabled={disabled}
      onClick={e => {clickHandler(e)}}>
      {isLoading && 
        <option></option>}
      {!isLoading && data.map((el, index) => (
        // selected={(selectedValue === el.value) ? true : false}
        <option key={index} className={`${styles.option} ${el.value !== 0 && " fw-bold"} textColor`} selected={selectedValue === el.value ? true : false} value={el.value}>
          {el.name}
          {/* {console.log(selectedValue === el.value ? "match found " + el.name + el.value : "")} */}
        </option>
      ))}
    </select>
  );
}

export default Select;
